import * as GlobalS from "@/components/styled";
import { ProjectLeaderFields } from "@/containers/Project/components/ProjectLeaders";
import { ProjectUserPermissions } from "@/enums";
import { useProjectContext } from "@/providers";
import { useUpdateProjectLeadersMutation } from "@/services";
import { Form, Spin } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";

export const ProjectLeadersForm = () => {
  const intl = useIntl();
  const { canUser, setProject, project } = useProjectContext();

  const [form] = Form.useForm();

  const [properties, setProperties] = useState(null);

  const [updateProjectLeaders, { isLoading }] =
    useUpdateProjectLeadersMutation();

  useEffect(() => {
    if (!project) return;

    const { projectLeaders, backupProjectLeader } = project;
    setProperties([
      {
        propertyName: "projectLeaders",
        initialValues: projectLeaders,
      },
      {
        propertyName: "backupProjectLeader",
        initialValues: backupProjectLeader,
      },
    ]);
    form.setFieldsValue({
      projectLeaders,
      backupProjectLeader,
    });
  }, [project, form]);

  const handleValuesChange = () => {
    const { backupProjectLeader, projectLeaders } = form.getFieldsValue();
    updateProjectLeaders({
      id: project.id,
      regionalProjectLeaders: projectLeaders,
      backupProjectLeader,
    })
      .unwrap()
      .then((project) => {
        setProject(project);
        toast.success(
          intl.formatMessage({ id: "regionalProjectLeaderCard.success" })
        );
      })
      .catch(() => {
        toast.error(
          intl.formatMessage({ id: "regionalProjectLeaderCard.error" })
        );
      });
  };

  return (
    <Form layout="vertical" form={form} name={"ProjectLeadersForm"}>
      {project ? (
        <>
          {properties && (
            <GlobalS.GrayCard
              size="small"
              title={intl.formatMessage({
                id: "regionalProjectLeaderCard.title",
              })}
            >
              <ProjectLeaderFields
                regionalProjectLeadersProp={properties?.[0]}
                backupProjectLeaderProp={properties?.[1]}
                formRef={form}
                readOnly={!canUser(ProjectUserPermissions.EditProjectLeaders)}
                isSaving={isLoading}
                fromProject={true}
                onFinish={handleValuesChange}
              />
            </GlobalS.GrayCard>
          )}
        </>
      ) : (
        <Spin />
      )}
    </Form>
  );
};
